/* Warmora — bundle selector, animated ring, add-to-cart, sticky ATC */
(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- animated "MOST POPULAR" ring ---------- */
  var SVGNS = 'http://www.w3.org/2000/svg';
  function roundedRectPath(x, y, w, h, r, laps) {
    var d = 'M ' + (x + r) + ' ' + y;
    for (var i = 0; i < laps; i++) {
      d += ' H ' + (x + w - r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + (x + w) + ' ' + (y + r);
      d += ' V ' + (y + h - r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + (x + w - r) + ' ' + (y + h);
      d += ' H ' + (x + r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + x + ' ' + (y + h - r);
      d += ' V ' + (y + r) + ' A ' + r + ' ' + r + ' 0 0 1 ' + (x + r) + ' ' + y;
    }
    return d + ' Z';
  }

  var ringCounter = 0;
  function drawRing(ring) {
    var svg = ring.querySelector('.wm-ring__svg');
    var w = ring.clientWidth, h = ring.clientHeight;
    if (!svg || !w || !h) return;
    if (ring._w === w && ring._h === h) return;
    ring._w = w; ring._h = h;
    var text = ring.getAttribute('data-text') || 'MOST POPULAR';
    var inset = 12.2, radius = 35.2;
    var pw = w - inset * 2, ph = h - inset * 2;
    var perim = 2 * (pw - 2 * radius) + 2 * (ph - 2 * radius) + 2 * Math.PI * radius;
    var id = 'wm-ring-path-' + (++ringCounter);
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    var path = document.createElementNS(SVGNS, 'path');
    path.setAttribute('id', id);
    path.setAttribute('fill', 'none');
    path.setAttribute('d', roundedRectPath(inset, inset, pw, ph, radius, 2));
    svg.appendChild(path);

    // measure label width
    var probe = document.createElementNS(SVGNS, 'text');
    probe.textContent = text;
    svg.appendChild(probe);
    var tw = probe.getComputedTextLength ? probe.getComputedTextLength() : text.length * 6.5;
    svg.removeChild(probe);
    if (!tw) tw = text.length * 6.5;

    var unit = tw + 26; // label + bullet + gaps
    var pairs = Math.max(2, Math.floor(perim / unit));
    var spacing = perim / (pairs * 2);
    var dur = perim / 20; // px per second
    var t = document.createElementNS(SVGNS, 'text');
    t.setAttribute('text-anchor', 'middle');
    for (var i = 0; i < pairs * 2; i++) {
      var tp = document.createElementNS(SVGNS, 'textPath');
      var start = spacing * (i + 1);
      tp.setAttribute('href', '#' + id);
      tp.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + id);
      tp.setAttribute('startOffset', start);
      var anim = document.createElementNS(SVGNS, 'animate');
      anim.setAttribute('attributeName', 'startOffset');
      anim.setAttribute('from', start);
      anim.setAttribute('to', start + perim);
      anim.setAttribute('dur', dur + 's');
      anim.setAttribute('repeatCount', 'indefinite');
      tp.appendChild(anim);
      tp.appendChild(document.createTextNode(i % 2 === 0 ? text : '•'));
      t.appendChild(tp);
    }
    svg.appendChild(t);
  }

  /* ---------- bundle ---------- */
  function Bundle(root) {
    this.root = root;
    this.format = root.getAttribute('data-money-format') || '{{amount}}';
    this.upsellVariant = root.getAttribute('data-upsell-variant');
    this.upsellPrice = parseInt(root.getAttribute('data-upsell-price'), 10) || 0;
    try {
      this.variants = JSON.parse(root.querySelector('[data-wm-variants]').textContent);
    } catch (e) { this.variants = []; }
    this.priceById = {};
    this.compareById = {};
    for (var i = 0; i < this.variants.length; i++) {
      this.priceById[this.variants[i].id] = this.variants[i].price;
      this.compareById[this.variants[i].id] = this.variants[i].compare || 0;
    }
    this.bars = Array.prototype.slice.call(root.querySelectorAll('.wm-bar'));
    this.atc = root.querySelector('[data-wm-atc]');
    this.error = root.querySelector('.wm-bundle__error');
    this.bind();
    this.refreshPrices();
    this.drawRings();
  }

  Bundle.prototype.bind = function () {
    var self = this;
    this.bars.forEach(function (bar) {
      var main = bar.querySelector('.wm-bar__main');
      var select = function () { self.select(bar); };
      main.addEventListener('click', select);
      main.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(); }
      });
      bar.addEventListener('click', function (e) {
        if (!bar.classList.contains('wm-bar--selected') && !e.target.closest('select')) select();
      });
      var up = bar.querySelector('.wm-upsell');
      if (up) {
        var toggle = function (e) {
          if (!bar.classList.contains('wm-bar--selected')) return; // first click selects the bar
          e.stopPropagation();
          var on = !up.classList.contains('wm-upsell--checked');
          up.classList.toggle('wm-upsell--checked', on);
          up.setAttribute('aria-checked', on);
        };
        up.addEventListener('click', toggle);
        up.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(e); }
        });
      }
      bar.querySelectorAll('select.wm-bar__variant-select').forEach(function (s) {
        s.addEventListener('change', function () {
          self.refreshPrices();
          self.syncSticky();
        });
      });
    });
    if (this.atc) this.atc.addEventListener('click', function () { self.addToCart(self.atc); });
    var buy = this.root.querySelector('[data-wm-buynow]');
    if (buy) buy.addEventListener('click', function () { self.buyNow(buy); });
    window.addEventListener('resize', function () { self.drawRings(); });
  };

  Bundle.prototype.select = function (bar) {
    this.bars.forEach(function (b) {
      var on = b === bar;
      b.classList.toggle('wm-bar--selected', on);
      var m = b.querySelector('.wm-bar__main');
      if (m) m.setAttribute('aria-checked', on);
    });
    this.syncSticky();
    this.drawRings();
  };

  Bundle.prototype.selected = function () {
    return this.root.querySelector('.wm-bar--selected') || this.bars[0];
  };

  Bundle.prototype.refreshPrices = function () {
    var self = this;
    this.bars.forEach(function (bar) {
      var sels = bar.querySelectorAll('.wm-bar__variant-select');
      var full = 0;
      var price = 0;
      var pct = parseFloat(bar.getAttribute('data-discount-pct')) || 0;
      if (bar.hasAttribute('data-pack')) {
        // pack mode: one variant per tier, exact price + compare-at price from Shopify
        var vid = sels.length ? sels[0].value : null;
        price = self.priceById[vid] || 0;
        full = Math.max(price, self.compareById[vid] || 0);
      } else {
        sels.forEach(function (s) {
          var unit = self.priceById[s.value] || 0;
          full += unit;
          price += unit - Math.floor(unit * pct / 100);
        });
      }
      var disc = full - price;
      var p = bar.querySelector('[data-price]');
      var fp = bar.querySelector('[data-full-price]');
      if (p) p.textContent = formatMoney(price, self.format);
      if (fp) { fp.textContent = formatMoney(full, self.format); fp.hidden = disc <= 0; }
    });
  };

  Bundle.prototype.drawRings = function () {
    var rings = this.root.querySelectorAll('.wm-ring');
    requestAnimationFrame(function () { rings.forEach(drawRing); });
  };

  Bundle.prototype.items = function () {
    var bar = this.selected();
    var counts = {}, order = [];
    bar.querySelectorAll('.wm-bar__variant-select').forEach(function (s) {
      var id = s.value;
      if (!counts[id]) { counts[id] = 0; order.push(id); }
      counts[id]++;
    });
    var items = order.map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
    var up = bar.querySelector('.wm-upsell');
    if (up && up.classList.contains('wm-upsell--checked') && this.upsellVariant) {
      items.push({ id: parseInt(this.upsellVariant, 10), quantity: 1 });
    }
    return items;
  };

  Bundle.prototype.addToCart = function (button) {
    var self = this;
    if (!button || button.classList.contains('loading')) return;
    var items = this.items();
    if (!items.length) return;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: items };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }
    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    if (this.error) { this.error.hidden = true; this.error.textContent = ''; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (self.error) { self.error.textContent = res.description || res.message || 'Error'; self.error.hidden = false; }
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wm-bundle', productVariantId: items[0].id, cartData: res });
        }
        if (cart && cart.renderContents && res.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(res);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { window.location = (window.routes && window.routes.cart_url) || '/cart'; })
      .finally(function () {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
      });
  };

  /* Buy it now: straight to checkout with the selected bundle (cart permalink) */
  Bundle.prototype.buyNow = function (button) {
    var items = this.items();
    if (!items.length) return;
    button.classList.add('loading');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    window.location.href = root + 'cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(',');
  };

  /* sticky bar mirrors the first variant select of the selected tier */
  Bundle.prototype.syncSticky = function () {
    var sticky = document.querySelector('[data-wm-sticky="' + this.root.getAttribute('data-section-id') + '"]');
    if (!sticky) return;
    var s = sticky.querySelector('select');
    var first = this.selected().querySelector('select.wm-bar__variant-select');
    if (s && first && s.value !== first.value) s.value = first.value;
    if (this.selected().hasAttribute('data-pack')) {
      var sp = sticky.querySelector('.wm-sticky__price');
      var bp = this.selected().querySelector('[data-price]');
      if (sp && bp) sp.textContent = bp.textContent;
    }
  };

  function initSticky(bundle) {
    var id = bundle.root.getAttribute('data-section-id');
    var sticky = document.querySelector('[data-wm-sticky="' + id + '"]');
    if (!sticky) return;
    var btn = sticky.querySelector('[data-wm-sticky-atc]');
    var s = sticky.querySelector('select');
    if (s) {
      s.addEventListener('change', function () {
        var first = bundle.selected().querySelector('select.wm-bar__variant-select');
        if (first) { first.value = s.value; bundle.refreshPrices(); }
      });
    }
    if (btn) btn.addEventListener('click', function () { bundle.addToCart(btn); });
    var target = bundle.atc || bundle.root;
    var shown = false;
    function update() {
      var r = target.getBoundingClientRect();
      var show = r.bottom < 0;
      if (show !== shown) { shown = show; sticky.classList.toggle('wm-sticky--visible', show); }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function init() {
    document.querySelectorAll('.wm-bundle').forEach(function (el) {
      if (el._wm) return;
      el._wm = new Bundle(el);
      initSticky(el._wm);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        document.querySelectorAll('.wm-ring').forEach(function (r) { r._w = 0; drawRing(r); });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.WarmoraFormatMoney = formatMoney;
})();
